import * as React from "react";
import { useCallback, useState } from "react";

interface FormProps {
  onUpdateFormData?: (formData: any) => void;
  children: Function | React.ReactElement
}


export const Form: React.SFC<FormProps> = (props) => {
  const [formData, setFormData] = useState<any>({});

  const resetFormData = () => {
    setFormData({})
  }

  const onUpdateField = (field: string, value: any) => {
    const newFormData = Object.assign({},
      formData, {
        [field]: value
      }
    )
    setFormData(newFormData);

    props.onUpdateFormData && props.onUpdateFormData(newFormData);
  };

  if (typeof props.children === "function") {
    return (props.children as Function)({
        onUpdateField,
        formData,
        resetFormData
    })
  } else {
    return React.cloneElement((props.children as React.ReactElement), {
        onUpdateField,
        formData,
        resetFormData
    });
  }
}